import { render } from "./SingIn.vue?vue&type=template&id=0905d8d5"
import script from "./SingIn.vue?vue&type=script&lang=js"
export * from "./SingIn.vue?vue&type=script&lang=js"

import "./SingIn.vue?vue&type=style&index=0&id=0905d8d5&lang=css"

import exportComponent from "/home/marc/E09/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__